((Product, $) => {
  "use strict";

  const $dom = {};

  let settings = {};

  let colorPrefix = ``;

  let currentVariantOptionValues = []
  let lastHoveredOption = null;

  const cacheDom = () => {
    $dom.productStickyButton = $(".product-template .js-product-sticky-button");
    $dom.productOptions = $(".product-template  .purchase-box");

    $dom.promoBar = $(".promos");
    $dom.mobileHeader = $("header");
    $dom.desktopHeader = $(".header");

    $dom.productTitleVariant = $(".product-template .js-product-title-variant");
    $dom.productCustomizerPrice = $(".product-template .product--product-customizer-price");
    $dom.productCustomizerDesc = $(".product-template .js-product-customizer-desc");
    $dom.productCustomizerSource = $(".product-template .product-customizer-option-description");
    $dom.productVariantSelector = $(".product-template .js-product-variant-selector");
    $dom.productVariantDisplayValue = $(".product-template .js-product-variant-display-value");
    $dom.productColorGroupContainer = $(`.product-template .js-product-variant-color`);

    $dom.productFeaturedSlider = $(".product-template .js-product-featured-slider");
    $dom.productThumbnailSlider = $(".product-template .js-product-thumbnails-slider");

    $dom.addToCartForm = $('.product-template #AddToCartForm');
    $dom.productVariantSize = $('.product-template .product--variant-size');
    $dom.productATCButton = $('.product-template .product--atc-button');
    $dom.productUpsellForm = $('.product-template .product-upsell__form');
  };

  const showStickyButton = () => {
    $dom.productStickyButton.addClass("is-active");
  };

  const hideStickyButton = () => {
    $dom.productStickyButton.removeClass("is-active");
  };

  const initStickyButton = () => {
    const headerHeight =
      $(window).width() > 800
        ? $dom.mobileHeader.height() +
          $dom.promoBar.height() +
          $dom.desktopHeader.height()
        : $dom.mobileHeader.height() + $dom.promoBar.height();
    const optionsBottom =
      $dom.productOptions.offset().top + $dom.productOptions.height();
    if ($(window).scrollTop() + headerHeight > optionsBottom) {
      showStickyButton();
    } else {
      hideStickyButton();
    }
  };

  const initSettings = () => {
    $(".product-template .js-product-variant-option-selector").each(function () {
      const optionName = $(this).data("name");
      const optionNum = $(this).data("option");
      const value = $(this).val();
      settings[optionNum] = {
        name: optionName,
        value: value,
      };
      if (optionName !== `Color`) return;
      colorPrefix = $(this).data(`color-prefix`);
    });
  };

  const initSwatchColor = () => {
    let variantId;
    const product = window.productJSON;
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get(`variant`)) {
      variantId = urlParams.get(`variant`);
    } else {
      const availableVariant = product.variants
        .find((variant) => {
          return variant.available && (
            !product.hide_color_variants || (
              product.hide_color_variants && !product.hide_color_variants.includes(variant.option1)
            )
          );
        });
      variantId = availableVariant ? availableVariant.id : product.variants[0].id;
    }

    let colorName = product.variants[0].option1;
    product.variants.forEach(variant => {
      if(variant.id.toString() == variantId) {
        colorName = variant.option1;
      }
    });

    $dom.productVariantDisplayValue.each(function(index){
      if ($(this).data(`swatch-color`) && $(this).data(`value`) == colorName) {
        if (isGroupProduct() && $(this).data(`product-handle`) !== product.handle) {
          return;
        }
        changeVariantOption($(this));
      }
    });
    $(document).trigger(`initialSwatchSet`);
  }

  const updateOptionObject = ($that) => {
    window.Product.lastUpdatedOption = $that.parent().data('option');
  }

  const changeVariantOption = ($that) => {
    if (!$that.hasClass("is-active")) {
      // select the nearest list of custom variant selectors
      const $displayList = $that.closest(".product--variant-display").find(".product--variant-display-list");
      // get the option data from this list
      const optionName = $($displayList[0]).data("name");

      let currentValue = $that.data("value").toString().toLowerCase();
      // update the single option selector using the data attribute on custom selector
      const $selectList = $(
        `.product-template .js-product-variant-option-selector[data-name='${optionName}']`
      );

      // add the active class to the clicked selector
      $displayList.find(".is-active").removeClass("is-active");
      $that.addClass("is-active");

      $selectList.find("option").each(function () {
        if ($(this).val().toString().toLowerCase() === currentValue) {
          $selectList.val($(this).val()).change();
          return false;
        }
      });
    }
  };

  const setCurrentOptionValues = () => {
    const productOptionCurrentValues = Array.from(
        document.querySelectorAll('.product-template .product--variant-display-option .js-product-current-variant-option')
      )
      .map(span => {
        // remove 'Inseam' and re-add only one (avoids a bug on undefined variants)
        let value = span.getAttribute('data-value').replace('Inseam ', '');
        if(span.getAttribute('data-name') === 'Inseam') {
          value = 'Inseam ' + value;
        }
        return {
          index: Number.parseInt(span.dataset.index, 10),
          value
        };
      })
      .sort((option1, option2) => {
        // sort options by index since "inseam" option is pushed to the bottom
        if (option1.index > option2.index) {
          return 1;
        } else if (option1.index === option2.index) {
          return 0;
        } else {
          return -1;
        }
      });

    currentVariantOptionValues = productOptionCurrentValues.map((option) => option.value); // capri, xl (option names array)
  }

  // disable product variant selectors based on selected variant
  const updateDisabledVariantButtons = (first = false) => {
    const selectedOptions = Array.from(document.querySelectorAll('.product-template .js-product-variant-display-value.is-active')).map(li => {
      return li.parentElement.dataset.name;
    });
    const product = window.productJSON;
    const variantGroups = Array.from(
      document.querySelectorAll(".product-template .js-variant-option-control")
    );
    let filterProductOptions = [];

    const productObjList = product.options.map((option, index) => {
      return {
        option, index
      }
    });

    if(currentVariantOptionValues.length == selectedOptions.length ) {
      filterProductOptions = productObjList;
    } else if( currentVariantOptionValues.length - 1 == selectedOptions.length ){
      filterProductOptions = productObjList.filter(obj => !selectedOptions.includes(obj.option));
    }

    filterProductOptions.forEach(optionObj => {
      // options besides the current one
      const otherOptions = Object.keys(product.options).filter(option => option !== String(optionObj.index));
      // get an array of in-stock variants that matches the currentVariant
      // on at least one of the matching 'other' options
      const filteredInStockVariants = product.variants.filter(productVariant => {
        if(!productVariant.available) return false;
        for (let i = 0; i < otherOptions.length; i++) {
          if(currentVariantOptionValues[otherOptions[i]] != productVariant.options[otherOptions[i]]){
            return false;
          }
        }
        return true;

      })
      .map(productVariant => {
        return productVariant.options[optionObj.index];
      });

      // update this option's corresponding button selectors
      const thisOptionGroup = variantGroups.find(group => group.getAttribute('data-name') === optionObj.option);

      // HOTFIX STGFED-652 - Daniel L - Not a permanent solution
      // On load, some color options are set to "disabled" because the the product.selected_or_first_available_variant's size/inseam is OOS in that color.
      // Because the PDP does not show the size/inseam options as selected/highlighted on load, it become misleading as if the color was completely OOS.
      // Instead, only apply the "disabled" state to color after the user selects a variant option value (dont't update color options when param first equals true).
      // Side note: Make use of class 'color-oos' (applied via liquid) to handle the case when a color is 100% OOS in all variants.
      const isColorOption = optionObj.option.toLowerCase() === 'color';
      if (first && isColorOption) return;

      if (thisOptionGroup) {
        const theseOptions = Array.from(thisOptionGroup.querySelectorAll('.js-product-variant-display-value'));
        theseOptions.forEach(button => {
          button.classList.remove('is-disabled');
          const buttonValue = button.getAttribute('data-value');
          if(filteredInStockVariants.indexOf(buttonValue) === -1) {
            button.classList.add('is-disabled');
          }
        });
      }

    });
    if (product.available && !first) {
      const productFormBottom = document.querySelector('.product-template .product-form-bottom');
      productFormBottom.classList.remove('product-form-bottom--soldout')
    };
  }

  const selectFirstInStockOptions = () => {
    const steps = miySteps();
    const urlParams = new URLSearchParams(window.location.search);
    steps.forEach((step, index) => {
      const swatches = step.querySelectorAll('.js-product-variant-display-value:not(.color-oos)');
      const activeOOS = step.querySelector('.js-product-variant-display-value.is-active.color-oos');
      let activeSwatch = step.querySelector('.js-product-variant-display-value.is-active:not(.color-oos)');
      if (!activeSwatch) {
        activeSwatch = swatches[0];
      }

      if (activeOOS) {
        activeOOS.classList.remove('.is-active');
      }

      if (index === 0 && !urlParams.has(`step${step.dataset.step}`)) {
        $(activeSwatch).trigger('click');
      }
    });
  }

  const isGroupProduct = ($childElement = null) => {
    let $productTemplate = $childElement && $childElement.length > 0 && $childElement.closest(`.product-template`);
    if (!$productTemplate || $productTemplate.length <=0) {
      $productTemplate = $(`.product-template`);
    }
    return $productTemplate.length > 0 && $productTemplate.data(`group-product`);
  };

  const changeGroupProduct = ($that) => {
    if (!$that.hasClass(`is-active`)) {
      const $handleList = $(`#GroupProductSelector`);
      const new_product_handle = $that.data(`product-handle`);
      if ($handleList.length <= 0 || $handleList.find(`[value="${new_product_handle}"]`).length <= 0) {
        return;
      }

      $handleList.val(new_product_handle).change();
    }
  };

  const appendColorGroupListItem = ($productColorGroupContainer, $productVariantList, colorGroupTitle, colorsList, colorsInStock, product, showSale, productTemplateType) => {
    if (!$productColorGroupContainer) return;
    const optionNumber = $productColorGroupContainer.data(`option-number`);
    const enableSwatchProductImages = $productColorGroupContainer.data(`enable-swatch-product-images`);
    colorsList.forEach((value) => {
      const colorHandle = window.Helpers.handleize(value.toLowerCase());
      const fileName = `${ colorHandle }.jpg`;
      const colorVariant = product.variants.find((variant) => variant[optionNumber] === value);
      if (!colorVariant) return;
      let showSwatch = false;
      // If variant is on sale and category is sale
      if (
        showSale && 
        colorVariant.compare_at_price && 
        colorVariant.compare_at_price > colorVariant.price
      ) {
        showSwatch = true;
      } else if (
        !showSale && 
        (!colorVariant.compare_at_price || colorVariant.compare_at_price <= colorVariant.price)
      ) {
        let colorGroupCategory;
        if (isGroupProduct()) {
          colorGroupCategory = colorVariant.color_group_category;
        } else if (product.variant_metafields) {
          colorGroupCategory = product.variant_metafields[colorVariant.id].color_group_category;
        }
        if (colorGroupCategory && colorGroupTitle === colorGroupCategory) {
          // if variant color category matches color group title
          showSwatch = true;
        } else if (
          // if group product title matches group color group title
          (!colorGroupCategory || colorGroupCategory.length <= 0) &&
          (colorGroupTitle === product.color_prefix || 
          (colorGroupTitle.length <= 0 && !product.color_prefix))
        ) {
          showSwatch = true;
        }
      }

      if (showSwatch) {
        const ingotTextColor = isGroupProduct() ? colorVariant.textColorFromMetafield : product.variant_metafields[colorVariant.id].textColorFromMetafield;
        const ingotTextColorList = isGroupProduct() ? colorVariant.textColorsListFromMetafield : product.variant_metafields[colorVariant.id].textColorsListFromMetafield;
        const price = theme.Currency.formatMoney(colorVariant.price, window.StyleHatch.currencyFormat).replace(`.00`, ``).replace(`$`, ``);
        const $colorGroupItem = $(`<li class="product--variant-display-value product--variant-color-value js-${ productTemplateType }-variant-display-value"
          data-value="${ value }"
          data-swatch-id="${ colorVariant.id }"
          data-swatch-color="${ colorHandle }"
          data-variant-sku="${ colorVariant.sku }"
          data-text-color="${ ingotTextColor }"
          data-text-color-list="${ ingotTextColorList.join(`|`) }"
          data-product-handle="${ product.handle }"
          data-price="${ price }"
          data-is-last-layer="${ $productColorGroupContainer.data('is-last-layer') }"
          data-image-index="${$productColorGroupContainer.data('image-index') }"
          data-color-prefix="${ product.color_prefix || $productColorGroupContainer.data(`product-color-prefix`) }"
        ><span class="sr-only">${ value }</span></li>`);
        if (enableSwatchProductImages) {
          $colorGroupItem.addClass(`product--variant-color-value--image`);
          const variantImage = `${ window.bvaccel.media_url }color-${ product.handle }-${ colorHandle }.jpg`;
          $colorGroupItem.append(`<img srcset="${ window.theme.Images.getSizedImageUrl(`${ variantImage }`, '72x') }, ${ window.theme.Images.getSizedImageUrl(`${ variantImage }`, '144x') } 2x" alt="${ colorVariant.featured_image.alt }" />`);
        } else {
          $colorGroupItem.css(`backgroundImage`, `url(${ window.theme.Images.getSizedImageUrl(`${ window.bvaccel.media_url }color-swatch-${ fileName }`, '36x36') })`);
        }
        if (!colorsInStock.includes(isGroupProduct() ? `${product.handle}::${value}` : value)) {
          $colorGroupItem.addClass(`color-oos`);
        }
        $productVariantList.append($colorGroupItem);
      }
    });
  };

  const addColorGroup = async ($productColorGroupContainer, colorGroupTitle, colorsList, colorsInStock, showSale = false, productTemplateType, productDataOverride) => {
    if (!$productColorGroupContainer) return;
    const optionNumber = $productColorGroupContainer.data(`option-number`);
    const $colorGroup = $(`<div class="color-group"></div>`);
    if (colorGroupTitle.length > 0) {
      const $colorGroupTitle = $(`<p class="color-group-title">${ colorGroupTitle }</p>`);
      $colorGroup.append($colorGroupTitle);
    }
    const $productVariantList = $(`<ul class="product--variant-display-list product--variant-color-list js-variant-option-control" data-name="Color"  data-option="${ optionNumber }"></ul>`);
    if (isGroupProduct()) {
      Object.keys(window.bvaccel.group_products).forEach((groupProductKey) => {
        appendColorGroupListItem($productColorGroupContainer, $productVariantList, colorGroupTitle, colorsList, colorsInStock, window.bvaccel.group_products[groupProductKey], showSale, productTemplateType);
      });
    } else {
      let productData = window.productJSON;
      if (productTemplateType === `quickview`) {
        if (productDataOverride) {
          productData = productDataOverride;
        } else {
          const productHandle = $productColorGroupContainer.data(`product-handle`);
          if (!productHandle) return;
          window.collectionProducts = window.collectionProducts || {};
          if (!window.collectionProducts[productHandle]) {
            try {
              const data = await $.ajax({
                url: `/products/${productHandle}?view=json`,
                type: `GET`
              });
              window.collectionProducts[productHandle] = $.parseJSON(data);
            } catch (err) {
              console.error(err);
              console.error('Failed to get product data');
              return;
            }
          }
          productData = window.collectionProducts[productHandle];
        }
      }
      appendColorGroupListItem($productColorGroupContainer, $productVariantList, colorGroupTitle, colorsList, colorsInStock, productData, showSale, productTemplateType);
    }
    if ($productVariantList.children().length > 0) {
      $colorGroup.append($productVariantList);
      $productColorGroupContainer.append($colorGroup);
    }
  };

  const initColorGroups = async ($productColorGroupContainer, productTemplateType = `product`, productDataOverride) => {
    if (!$productColorGroupContainer) return;
    const optionValues = $productColorGroupContainer.data(`option-values`);
    const optionNumber = $productColorGroupContainer.data(`option-number`);
    let colorGroupsList = [];
    let colorsInStock;
    let variantOnSale;
    if (!optionValues || !optionNumber) return;

    if (isGroupProduct()) {
      colorGroupsList = Array.from(
        new Set(
          Object.keys(window.bvaccel.group_products).reduce((accArray, groupProductKey) => {
            return accArray.concat(window.bvaccel.group_products[groupProductKey].variants.map((variant) => variant.color_group_category));
          }, [])
        )
      );
      colorGroupsList = colorGroupsList.concat($productColorGroupContainer.data(`color-prefixes`));
      colorsInStock = Array.from(
        new Set(
          Object.keys(window.bvaccel.group_products).reduce((accArray, groupProductKey) => {
            const groupProduct = window.bvaccel.group_products[groupProductKey];
            return accArray
              .concat(
                groupProduct.variants
                  .filter((variant) => variant.available  && !groupProduct.hide_color_variants.includes(variant[optionNumber]))
                  .map((variant) => `${groupProductKey}::${variant[optionNumber]}`)
              );
          }, [])
        )
      );
      variantOnSale = Boolean(Object.keys(window.bvaccel.group_products).find((groupProductKey) => Boolean(window.bvaccel.group_products[groupProductKey].variants.find((variant) => {
        return optionValues.includes(variant[optionNumber]) && variant.compare_at_price && variant.compare_at_price > variant.price;
      }))));
    } else {
      let productData = window.productJSON;
      if (productTemplateType === `quickview`) {
        if (productDataOverride) {
          productData = productDataOverride;
        } else {
          const productHandle = $productColorGroupContainer.data(`product-handle`);
          if (!productHandle) return;
          window.collectionProducts = window.collectionProducts || {};
          if (!window.collectionProducts[productHandle]) {
            try {
              const data = await $.ajax({
                url: `/products/${productHandle}?view=json`,
                type: `GET`
              });
              window.collectionProducts[productHandle] = $.parseJSON(data);
            } catch (err) {
              console.error(err);
              console.error('Failed to get product data');
              return;
            }
          }
          productData = window.collectionProducts[productHandle];
        }
      }
      if (productData.variant_metafields) {
        colorGroupsList = Array.from(
          new Set(
            Object.keys(productData.variant_metafields).map((variantId) => productData.variant_metafields[variantId].color_group_category)
          )
        );
      }
      colorsInStock = Array.from(
        new Set(
          productData.variants
            .filter((variant) => variant.available && !productData.hide_color_variants.includes(variant[optionNumber]))
            .map((variant) => variant[optionNumber])
        )
      );
      variantOnSale = Boolean(productData.variants.find((variant) => {
        return optionValues.includes(variant[optionNumber]) && variant.compare_at_price && variant.compare_at_price > variant.price;
      }));
    }

    colorGroupsList = colorGroupsList.filter((colorGroup) => colorGroup && colorGroup.length > 0);
    // Add default color groups
    addColorGroup($productColorGroupContainer, ``, optionValues, colorsInStock, false, productTemplateType, productDataOverride);
    // Add color category groups
    colorGroupsList.forEach((colorGroup) => {
      addColorGroup($productColorGroupContainer, colorGroup, optionValues, colorsInStock, false, productTemplateType, productDataOverride);
    });
    // Add sale color groups
    if (variantOnSale) {
      addColorGroup($productColorGroupContainer, `Sale`, optionValues, colorsInStock, true, productTemplateType, productDataOverride);
    }

    $dom.productVariantDisplayValue = $(".product-template .js-product-variant-display-value");
  };

  const bindUIActions = () => {
    $(window).on("scroll", function () {
      if (!$dom.productStickyButton.hasClass("is-clicked")) {
        initStickyButton();
      }
    });

    $(window).on("resize", function () {
      initStickyButton();
    });

    $dom.productStickyButton.on("click", function (e) {
      e.preventDefault();
      const $that = $(this);

      if (!$that.hasClass("is-clicked")) {
        $that.addClass("is-clicked");
        hideStickyButton();

        const headerHeight =
          $(window).width() > 700
            ? $dom.mobileHeader.height() +
              $dom.promoBar.height() +
              $dom.desktopHeader.height()
            : $dom.mobileHeader.height() + $dom.promoBar.height();
        const optionsTop = $dom.productOptions.offset().top;

        $("html, body").animate(
          {scrollTop: optionsTop - headerHeight},
          1000,
          function () {
            $that.removeClass("is-clicked");
          }
        );
      }
    });

    $dom.productVariantDisplayValue.on("click", function () {
      const $element = $(this);
      if(isMIY()){
        changeMIYOption(this);
        updateProductImage($element);
        updateMIYOption(this);
        updateMIYQuery();
      } else {
        const $variantOptionControl = $element.closest(`.js-variant-option-control`);
        const optionName = $variantOptionControl.data(`name`);
        if (optionName === `Color`) {
          colorPrefix = $element.data(`color-prefix`) || ``;
        }
        if (isGroupProduct()) {
          changeGroupProduct($element);
        }
        updateOptionObject($element);
        changeVariantOption($element);
      }
    });

    // temporary disable

    $('.product-template [data-name="Color"] .js-product-variant-display-value').on(
      "mouseenter",
      function () {
        const $element = $(this);
        const value = $element.data(`color-prefix`) ? `${$element.data('color-prefix')} ${$element.data('value')}` : $element.data(`value`);
        $element
          .closest(".product--variant-display-option")
          .find(".js-product-current-variant-option")
          .text(value);
      }
    );

    $('.product-template [data-name="Color"] .js-product-variant-display-value').on(
      "mouseout",
      function () {
        const $displayList = $(this)
          .closest(".product--variant-display-list")
        const optionNum = $displayList.data(`option`);
        const optionName = $displayList.data(`name`);
        $(this)
          .closest(".product--variant-display-option")
          .find(".js-product-current-variant-option")
          .text(optionName === `Color` ? `${colorPrefix} ${settings[optionNum].value}` : settings[optionNum].value);
      }
    );

    $(".product-template .js-product-variant-option-selector").on("change", function (e) {
      const optionName = $(this).data("name");
      const optionNum = $(this).data("option");
      const optionIndex = Number(optionNum.replace("option","")) - 1;
      const value = $(this).val();
      settings[optionNum].value = value;
      $(`.product-template .js-product-current-variant-option[data-name=${optionName}]`).attr(
        'data-value',
        value.charAt(0).toUpperCase() + value.slice(1)
      );
      $(this)
        .closest(".product--variant-display-option")
        .find(".js-product-current-variant-option")
        .text(optionName === `Color` ? `${colorPrefix} ${value}` : value);

      setCurrentOptionValues();
      updateDisabledVariantButtons();
      const trimmedValue = currentVariantOptionValues.length && currentVariantOptionValues[optionIndex].replace("Inseam", "");
      if(trimmedValue.length) {
        $(`.product-template .js-product-current-variant-option[data-name=${optionName}]`)
          .text(optionName === `Color` ? `${colorPrefix} ${trimmedValue}` : trimmedValue);
      }
      else {
        $(`.product-template .js-product-current-variant-option[data-name=${optionName}]`)
          .text(optionName === `Color` ? `${colorPrefix} ${value}` : value);
      }
    });

    $('.product-template .js-product-variant-display-value').on("mouseenter", (event) => {
      lastHoveredOption = event.currentTarget.parentElement.getAttribute('data-option');
      setCurrentOptionValues();
    });

    $dom.productUpsellForm.on(`submit`, (event) => {
      event.preventDefault();
      if (!window.InlineCart) return;

      window.InlineCart.miniCartAddProduct(event.currentTarget);
    });
  };

  const productValidation = () => {
    $dom.productATCButton.on('click', function(e) {

      e.preventDefault();
      let formIsValid = true;
      const validateSections = $('.product-template .product--variant-size');
      const validateBoxIsActive = $('.product-template .js-product-variant-box.is-active');

      if(validateSections.length === validateBoxIsActive.length) {
        formIsValid = false;
      }

      if (formIsValid) {
        $dom.productVariantSize.each(function () {
          if($(this).find('.product--variant-display-value.is-active').length) {
            $(this).find('.product-validation').removeClass('is-active');
            $(this).find('.product--variant-display-list').removeClass('is-error');
          } else {
            $(this).find('.product-validation').addClass('is-active');
            $(this).find('.product--variant-display-list').addClass('is-error');
          }
        });
      } else {
        $dom.addToCartForm.submit();
        $('.product-template .product-validation').removeClass('is-active');
        $('.product-template .product--variant-display-list').removeClass('is-error');
      }
    });
  };

  const initBISForm = () => {
    const miyWrapper = document.querySelector('.miy-step');
    if(!miyWrapper) {
      const bisInterval = setInterval(() => {
        if (typeof BIS !== 'undefined' && typeof BISPopover !== 'undefined' && typeof BISPopover.variants !== 'undefined') {
          clearInterval(bisInterval);

          const notificationCallback = (data) => {
            if (data.status == 'OK') {
              $('.bis-form__msg-container').removeClass('bis-form__msg-container--error');

              $('.bis-form__msg-container').append(`<p>${data.message}</p>`);
            } else {
              if (!$('.bis-form__msg-container').hasClass('bis-form__msg-container--error')) {
                $('.bis-form__msg-container').addClass('bis-form__msg-container--error');
              }

              for (const k in data.errors) {
                data.errors[k].forEach(m => {
                  $('.bis-form__msg-container').append(`<p>${m}</p>`);
                });
              }
            }
          };

          if ($('.bis-form').length && BIS.Config && BIS.Config.labels) {
            $('.bis-form__title').html(BIS.Config.labels.headline);
            $('.bis-form__description').html(BIS.Config.labels.body_copy);
            $('.bis-form__footer').html(BIS.Config.labels.footer_copy);
            $('.bis-form input[type="submit"]').val(BIS.Config.labels.button_label);

            if (BISPopover.variants.length) {
              BISPopover.variants.forEach(({ id, title }) => {
                $('.bis-form select').append(`<option value='${id}'>${title}</option>`);
              });
            }

            if (!BISPopover.product.available) {
              $('.bis-form').show();
            }

            $('.bis-form').submit(() => {
              $('.bis-form__msg-container').empty();

              const email = $('.bis-form input[type="email"]').val();
              const variantId = $('.bis-form select').val();
              const productId = BISPopover.product.id;

              BIS.create(email, variantId, productId).then(notificationCallback);

              return false;
            });
          }
        }
      });
    }
  };

  const accordionToggler = () => {
    const steps = miySteps();

    steps.forEach( (step, index) => {
      const stepName = step.querySelector('.miy-step-name');
      stepName.addEventListener('click', (event) => {
        event.preventDefault();
        if(step.dataset.isOpen === "true") {
          step.dataset.isOpen = "false";
        }
        else {
          const openSteps = miySteps(`[data-is-open="true"]`);
          openSteps.forEach((openStep) => {
            openStep.dataset.isOpen = `false`;
          })
          step.dataset.isOpen = "true";
          setTimeout(() => $(`html, body`).animate({
            scrollTop: $(step).offset().top - 100
          }, 300), 100);
        }
      });
    });
  }

  const updateProductImage = (swatch) => {
    const $swatch = $(swatch);
    const handle = $swatch.data('product-handle');
    const variantId = $swatch.data('swatch-id');
    const isLastLayer = $swatch.data('is-last-layer');
    const imageIndex = $swatch.data('image-index');
    const swatchContainerData = $swatch.closest('.miy-step__content-wrapper');

    if(handle) {
      fetch(`/products/${handle}.js`)
        .then((response) => {
          return response.json();
        })
        .then((product) => {
          const currentVariant = product.variants.find(variant => variant.id === variantId);
          let variantImageElement = document.querySelector(`.product-images--layer${imageIndex}`);
          if (variantImageElement && currentVariant.featured_image && currentVariant.featured_image.src) {
            variantImageElement.src = currentVariant.featured_image.src;
            setTimeout(() => {
              variantImageElement.classList.remove('visually-hidden');
            }, 100);
          }
        });
    }
  }

  const updateMIYOption = (swatch) => {
    const value = $(swatch).data('value');
    const wrapper = swatch.closest('.miy-step__color-swatches');
    const label = wrapper.querySelector('.js-product-current-variant-option');
    label.innerText = value;
    updateMIYPrice();
  }

  const maxAndMinPrice = () => {
    const priceHolder = Array.from(document.querySelectorAll('.product-header-price .product--price'));
    const steps = miySteps();
    let minPrice = 0;
    let maxPrice = 0;

    steps.forEach(step => {
      const colors = step.querySelectorAll('[data-swatch-color]');
      let colorMinPrice = parseInt(colors[0].dataset.price);
      let colorMaxPrice = parseInt(colors[0].dataset.price);
      colors.forEach(color => {
        const price = parseInt(color.dataset.price);
        if(price > colorMaxPrice) {
          colorMaxPrice = price;
        }
        if(price < colorMinPrice) {
          colorMinPrice = price
        }
      });
      minPrice += colorMinPrice;
      maxPrice += colorMaxPrice;
    });

    priceHolder.forEach((priceContainer, index) => {
      if(index === 0){
        priceContainer.textContent = priceHolder.length > 1 ? `$${minPrice}-` : `$${minPrice}`;
      }
      else {
        priceContainer.textContent = `$${maxPrice}`;
      }

    })
  }

  const updateMIYQuery = () => {
    const $selectedItems = $(`.miy-step .is-active[data-swatch-color]`);
    const urlParams = new URLSearchParams(window.location.search);
    let paramsUpdated = false;
    $selectedItems.each((index, swatch) => {
      const $swatch = $(swatch);
      const $step = $swatch.closest(`.miy-step`);
      if ($step.length <= 0 || urlParams.get(`step${$step.data('step')}`) === $swatch.data(`swatch-id`)) {
        return;
      }
      urlParams.set(`step${$step.data('step')}`, $swatch.data(`swatch-id`));
      paramsUpdated = true;
    });
    if (!paramsUpdated) {
      return;
    }
    const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}${window.location.hash}`;
    window.history.pushState(null, newUrl, newUrl);
  };

  const updateMIYPrice = () => {
    const footer = document.querySelector('.product_footer');
    const priceHolder = footer.querySelector('.product-price');
    const selectedItems = Array.from(document.querySelectorAll('.miy-step .is-active[data-swatch-color]'));
    disableATC();

    const personalizedStep = document.querySelector('.miy-step--personalized');
    const isPersonalized = personalizedStep ? personalizedStep.dataset.personalized === 'true' : false;
    if (isPersonalized) {
      const ingotPriceElem = personalizedStep.querySelector('.ingot-text');
      if (ingotPriceElem) {
        selectedItems.push(ingotPriceElem);
      }
    }

    const price = selectedItems.reduce((prevItem, currentItem) => {
      if(typeof prevItem === 'number') {
        return Number(currentItem.dataset.price) + prevItem;
      }
      else {
        return Number(currentItem.dataset.price) + Number(prevItem.dataset.price);
      }
    }, 0);

    priceHolder.innerHTML = `$${price}`;
  }

  const disableATC = () => {
    const steps = miySteps();
    const selectedItems = Array.from(document.querySelectorAll('.miy-step .is-active[data-swatch-color]'));
    const btnState = selectedItems.find(item => item.classList.contains('color-oos'));
    const btn = document.querySelector('.product_footer [data-atc-button]');
    const personalizedStep = document.querySelector('.miy-step--personalized[data-personalized="true"]');
    const initialsIncomplete = personalizedStep && !window.ProductPersonalize.hasCompleteInitials(personalizedStep);
    if (btnState || selectedItems.length < steps.length || initialsIncomplete) {
      btn.disabled = true;
      btn.classList.add('disabled');
    }
    else {
      btn.disabled = false;
      btn.classList.remove('disabled')
    }
  }

  const changeMIYOption = (that) => {
    if (!that.classList.contains("is-active")) {
      // select the nearest list of custom variant selectors
      const displayList = that.closest(".product--variant-display-list");
      // get the option data from this list
      const currentValue = that.dataset.value.toString().toLowerCase();
      const currentColor = displayList.closest('.miy-step__color-swatches').querySelector('.js-product-current-variant-option');
      currentColor.textContent = currentValue;
      currentColor.dataset.value = currentValue;

      // add the active class to the clicked selector
      $(displayList).find(".is-active").removeClass("is-active");
      that.classList.add("is-active");
    }
  }

  const isMIY = () => (
    document.querySelector('.miy-step')
  );

  const miySteps = (extraSelector = ``) => (
    [...document.querySelectorAll(`.miy-step${ extraSelector }`)]
  );

  const setMIYStepValue = (step_number, swatch_id) => {
    const $step = $(`[data-step="${step_number}"]`);
    if ($step.length <= 0) {
      return;
    }
    const $matching_swatch = $step.find(`.js-product-variant-display-value[data-swatch-id="${swatch_id}"]`);
    if ($matching_swatch.length <= 0) {
      return;
    }

    $matching_swatch.click();
  };

  const initMIY = () => {
    if (!isMIY()) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (Array.from(urlParams.values()).length <= 0) {
      return;
    }

    const $miySteps = $(`.miy-step`);
    for (let step_number = 0; step_number <= $miySteps.length; step_number++) {
      if (urlParams.has(`step${step_number}`)) {
        setMIYStepValue(step_number, urlParams.get(`step${step_number}`));
      }
    }
  };

  const init = () => {
    cacheDom();
    initColorGroups($dom.productColorGroupContainer);
    initStickyButton();
    initSettings();
    bindUIActions();
    setCurrentOptionValues();
    updateDisabledVariantButtons(true);
    selectFirstInStockOptions();
    initMIY();
    initBISForm();
    accordionToggler();

    if (miySteps().length > 0) {
      maxAndMinPrice();
    }
    else {
      initSwatchColor();
    }

    if($('.product-template .product--variant-size').css('display') !== 'none') {
      productValidation();
    }
  };

  Product.init = init;
  Product.initColorGroups = initColorGroups;
  Product.updateMIYPrice = updateMIYPrice;
  Product.disableATC = disableATC;
  Product.settings = settings;
})((window.Product = window.Product || {}), jQuery);
